import * as THREE from 'three';

function flattenBuffer(klass, elementBuffer, numElementsPerValue, indicesBuffer) {
  var flattenedBuffer = new klass(indicesBuffer.length * numElementsPerValue);

  var sourceIndex, destIndex;
  for (var v = 0; v < indicesBuffer.length; v++) {
    sourceIndex = indicesBuffer[v] * numElementsPerValue;
    destIndex = v * numElementsPerValue;
    for (var e = 0; e < numElementsPerValue; e++) {
      flattenedBuffer[destIndex + e] = elementBuffer[sourceIndex + e];
    }
  }

  return new THREE.BufferAttribute(flattenedBuffer, numElementsPerValue);
}

export function polyMeshToBufferGeometry({ faces, positions, normalMap, uvs }) {
  var geom = new THREE.BufferGeometry();

  geom.addAttribute('position', flattenBuffer(Float32Array, positions, 3, faces));

  if (normalMap) {
    geom.addAttribute('normal', flattenBuffer(Float32Array, normalMap.values, 3, normalMap.faces)); //normalMap.faces.length));
  }

  if (uvs) {
    var uvNames = Object.keys(uvs);
    uvNames.sort();

    // uv
    if (uvNames.length >= 1) {
      var uvMap = uvs[uvNames[0]];
      geom.addAttribute('uv', flattenBuffer(Float32Array, uvMap.values, 2, uvMap.faces)); // uvMap.faces.length));
    }

    // uv2
    if (uvNames.length >= 2) {
      var uvMap = uvs[uvNames[1]];
      geom.addAttribute('uv2', flattenBuffer(Float32Array, uvMap.values, 2, uvMap.faces)); //uvMap.faces.length));
    }
  }

  return geom;
}



// WEBPACK FOOTER //
// ./src/translators/polyMesh.js